import { CTASection as BaseCTASection } from '@roselabs-io/saas-shell'

export function CTASection() {
  return (
    <BaseCTASection
      badgeText="Start monitoring today"
      badge={{
        bgColor: 'bg-primary-100',
        borderColor: 'border-primary-300',
        textColor: 'text-primary-800',
        pulseColor: 'bg-primary-500',
      }}
      headingLine1="Ready to monitor your"
      headingLine2="applications?"
      gradientColor="#dc2626"
      description="Join developers who trust Falcon to keep their apps running. Start with our free forever tier—no credit card required."
      primaryButtonText="Start Free"
      secondaryButtonText="View Pricing"
      secondaryButtonLink="#pricing"
      trustIndicators={[
        'No credit card required',
        '3 apps free forever',
        'Setup in under 5 minutes',
      ]}
      stats={[
        { value: '<5 min', label: 'Setup time' },
        { value: '100%', label: 'Free tier included' },
        { value: '$20/mo', label: 'Starter plan pricing' },
      ]}
      statsColor="text-primary-600"
      sectionClassName="bg-slate-300"
      decorativeColors={{
        topLeft: 'bg-primary-500/5',
        bottomRight: 'bg-accent-500/5',
      }}
    />
  )
}
